<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-8 mx-auto">
        <div class="modal-content border-0 shadow pb-4">
          <div class="modal-header pb-0 border-0">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-block d-flex ms-auto"
                style="left: 0; top: 0"
                @click="close"
              >
                <v-icon
                  icon="times"
                  width="20"
                  height="20"
                />
              </button>
            </div>
          </div>
          <div class="col-12 col-md-10 mx-auto">
            <div class="h5 mb-3 me-auto">
              Générer une
              <span class="highlight highlight-pink-300">attestation nominative</span>
            </div>
            <div
              v-if="haveEmployees"
              class="input-group d-flex flex-md-row flex-column justify-content-md-around justify-content-center"
            >
              <div
                class="form-check px-0 text-center mx-auto mb-1"
                style="max-width: 279px"
              >
                <label
                  class="form-check-label m-0"
                  data-children-count="1"
                >
                  <input
                    id="employee-exist"
                    v-model="withExistEmployee"
                    type="radio"
                    class="form-check-input px-0 mx-0"
                    value="true"
                    @click="setCheckbox"
                  >
                </label>
                <div class="d-flex flex-column">
                  <div class="fw-bold my-1">
                    Employé existant
                  </div>
                </div>
              </div>
              <div
                class="form-check px-0 text-center mx-auto mb-1"
                style="max-width: 279px"
              >
                <label
                  class="form-check-label m-0"
                  data-children-count="2"
                >
                  <input
                    id="new-employee"
                    v-model="withExistEmployee"
                    type="radio"
                    class="form-check-input px-0 mx-0"
                    @click="setCheckbox"
                  >
                </label>
                <div class="d-flex flex-column">
                  <div class="fw-bold my-1">
                    Nouvel employé
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div v-if="haveEmployees && withExistEmployee">
                <v-select
                  input-id="employee-id"
                  label="Sélectionner un employé"
                  module-name="employee"
                  getter-name="get"
                  placeholder="Nicolas Moreau"
                  :list="employeesNames"
                  :setter-function="setSelectEmployee"
                  class="mb-1"
                />
              </div>
              <div v-else>
                <div class="row">
                  <v-input
                    input-id="employee-fname"
                    label="Prénom"
                    class="col-6 mb-1"
                    placeholder="Nicolas"
                    module-name="employee"
                    getter-name="get"
                    :getter-function="({ firstName }) => firstName"
                    path="employee.firstName"
                  />
                  <v-input
                    input-id="employee-lname"
                    label="Nom"
                    class="col-6 mb-1"
                    placeholder="Moreau"
                    module-name="employee"
                    getter-name="get"
                    :getter-function="({ lastName }) => lastName"
                    path="employee.lastName"
                  />
                </div>
                <v-input
                  input-id="employee-email"
                  placeholder="nicolas.moreau@gmail.com"
                  class="mb-1"
                  mask="email"
                  label="E-mail"
                  module-name="employee"
                  getter-name="get"
                  :getter-function="({ email }) => email"
                  path="employee.email"
                  :input-validation="validateEmail"
                />
              </div>
              <div class="row mb-1">
                <v-calendar
                  input-id="travel-start-date"
                  class="col-6"
                  module-name="employee"
                  label="Du"
                  getter-name="get"
                  :getter-function="get"
                  path="startDate"
                  :disabled-dates="{ to: disabledDates }"
                />
                <v-calendar
                  input-id="travel-end-date"
                  class="col-6"
                  module-name="employee"
                  label="Au"
                  getter-name="get"
                  :getter-function="get"
                  path="endDate"
                  :disabled-dates="{ to: disabledDates }"
                />
              </div>
              <div
                v-if="dateError !== null"
                class="col-12 text-danger mt-1 mb-2"
              >
                {{ dateError }}
              </div>
              <div>
                <v-search-country
                  label="Pays"
                  :item-action="toCountry"
                  :list="countries"
                />
                <template v-if="selectedCountry && selectedCountry.name">
                  <v-selector
                    v-if="selectedCountry && selectedCountry.name"
                    :name="selectedCountry.name"
                    icon="times"
                    class="bg-gray-300 mt-1 py-2 w-100"
                    @on-click-icon="removeCountry"
                  />
                </template>
              </div>
              <div
                v-if="error !== null"
                class="col-12 text-danger mt-1 mb-2"
              >
                {{ error }}
              </div>
            </div>
            <div class="col-12 mt-1">
              <v-loader
                :next="
                  () => {
                    return createEmployeeTravelCertificate();
                  }
                "
                :disable-button="isButtonDisabled"
                title="Générer"
                class="my-1 w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash-es';
import { mapGetters } from 'vuex';

import SelectorBasic from '@/components/common/input/SelectorBasic.vue';
import Input from '@/components/common/input/Input2.vue';
import CustomSelect from '@/components/common/input/CustomSelect2.vue';
import Calendar from '@/components/common/input/Date2.vue';
import { validateEmail, validateDefault } from '@/utils/validators';
import CountryAutoComplete from '@/components/documents/helpers/CountryAutoComplete.vue';

import { ui } from '@/mixins';

export default {
  name: 'EmployeeTravelModal',
  components: {
    'v-input': Input,
    'v-select': CustomSelect,
    'v-search-country': CountryAutoComplete,
    'v-selector': SelectorBasic,
    'v-calendar': Calendar,
  },
  mixins: [ui],
  data() {
    return {
      isLoading: false,
      validateEmail,
      validateDefault,
      get,
      withExistEmployee: true,
      dateError: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      employees: 'contracts/employees',
      countries: 'contracts/countries',
      employee: 'employee/get',
      resetCountry: 'employee/setDestination',
    }),
    disabledDates() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday;
    },
    isButtonDisabled() {
      if (this.employee.employee.email) {
        return (
          !this.validateEmail(this.employee.employee.email) ||
          !this.validateDefault(this.employee.employee.lastName) ||
          !this.validateDefault(this.employee.employee.firstName) ||
          !this.validateDefault(this.employee.destination) ||
          !this.validateDefault(this.employee.startDate) ||
          !this.validateDefault(this.employee.endDate)
        );
      }
      return (
        !this.validateDefault(this.employee.employee.lastName) ||
        !this.validateDefault(this.employee.employee.firstName) ||
        !this.validateDefault(this.employee.destination) ||
        !this.validateDefault(this.employee.startDate) ||
        !this.validateDefault(this.employee.endDate)
      );
    },
    haveEmployees() {
      if (this.employees && this.employees.length > 0) {
        return true;
      }
      return false;
    },
    selectedCountry() {
      return this.employee.destination;
    },
    employeesNames() {
      return this.employees.map(({ id, firstName, lastName, email }) => ({
        name: `${firstName} ${lastName}`,
        id,
        firstName,
        lastName,
        email,
      }));
    },
  },
  methods: {
    async createEmployeeTravelCertificate() {
      if (this.employee.endDate < this.employee.startDate) {
        this.dateError = 'La date de retour dois être égale ou après la date d\'aller';
      } else {
        try {
          this.isLoading = true;
          const documentId = await this.$store.dispatch(
            'contracts/createEmployeeTravelCertificate',
            this.employee
          );
          const certificate = {
            documentId,
            fileName: 'Attestation de déplacement professionnel',
          };
          await this.$store.dispatch('download/getDocument', certificate);
          this.ui_showModal(false);
          this.$router.go();
        } catch (err) {
          if (err.response.data.error.reason === 'The number of employees is exceeded') {
            this.error =
              'Le nombre de salariés que vous avez enregistré dépasse l\'effectif de votre entreprise';
            this.isLoading = false;
          } else if (err.response.data.error.reason === 'Amendment must be validate or cancelled') {
            this.error =
              'Vous devez d\'abord valider ou annuler votre avenant pour pouvoir générer l\'attestation';
            this.isLoading = false;
          }
        }
      }
    },
    close() {
      this.ui_showModal(false);
    },
    setSelectEmployee(user) {
      Object.assign(this.employee, {
        employee: {
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
        },
      });
    },
    setCheckbox() {
      Object.assign(this.employee, {
        employee: {
          id: null,
          email: null,
          firstName: null,
          lastName: null,
        },
      });
    },
    hide() {
      this.ui_focusScreen(false);
    },
    removeCountry() {
      this.$store.dispatch('employee/setValue', { destination: null }, { root: true });
    },
    toCountry(researchedCountry) {
      this.hide();
      this.$store.dispatch('employee/setValue', { destination: researchedCountry }, { root: true });
    },
  },
};
</script>

<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: unset;
  }
  div.btn-block:hover {
    background-color: var(--bs-primary);
    color: white;
  }
}
</style>
<style lang="scss" scoped>
@use "@/assets/styles/animation.scss";
</style>
